// Nøkkelen til Google Maps og om den mangler (da skjules kart- og søkefunksjoner).
export const LIBRARIES = ['places'];
export const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const KEY_MISSING = !API_KEY || API_KEY === 'din-google-maps-nokkel';
